export default "__VITE_PUBLIC_ASSET__2458b8db__"